




import { Vue } from "@/types.ts";

export default Vue.extend({
  name: "Ratio",
  computed: {
    percent(): number {
      if (this.value) return Math.round((this.value * 100) / this.max);
      else return 0;
    },
  },
  props: {
    value: {
      type: Number,
      required: true,
    },
    max: {
      type: Number,
      required: true,
    },
  },
});
